/* eslint-disable */
import React, { useEffect, useState } from 'react';
import './styles.scss';
import InventoryCategory from '../inventory-category';
import moment from 'moment';
import UpdateItemModal from '../modals/update-item-modal';
import { InventoryService } from 'services/inventory.services';
import { apiService } from '../../../utils/api';
import { MealType } from 'models/meal.model';
import { IMealItemCategory } from '../inventory-category/types';
import { STORAGE_KEYS } from 'utils/constants';

type ShopFormType = { amount: any; available_no: any; active: boolean };

const kitchenUrl = process.env.REACT_APP_KITCHEN_API_URL;

const InventoryBrand = ({
  mealCategories,
  onReloadData,
  brandId,
  brandName,
  workingHours
}: {
  mealCategories: any;
  onReloadData: any;
  brandId: any;
  brandName: any;
  workingHours: any;
}) => {
  const [allMeals, setAllMeals] = useState<IMealItemCategory[]>([]);
  const [shopForm, setShopForm] = useState<ShopFormType>({} as ShopFormType);
  const [mealUpdateLoading, setMealUpdateLoading] = useState(false);
  const [currentShopItem, setCurrentShopItem] = useState(null);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [addons, setAddons] = useState([]);
  const [addonsObj, setAddonsObj] = useState({
    name: 'Addons',
    meals: []
  } as any);

  const formatMeals = (meals: any) => {
    return meals?.map((itm: any) => {
      return { ...itm, altered: false };
    });
  };

  const fetchAddons = async () => {
    const resp: any = await InventoryService.getBrandAddons(brandId);
    const formattedAddons = formatMeals(resp.meals);
    setAddons(formattedAddons);
  };

  useEffect(() => {
    fetchAddons();
  }, []);

  useEffect(() => {
    const formattedMeals = handleSortMealData(mealCategories ? JSON.parse(mealCategories) : []);
    setAllMeals(formattedMeals?.mealsArr);
  }, [mealCategories]);

  useEffect(() => {
    setAddonsObj({
      name: 'Addons',
      meals: addons
    });
  }, [addons]);

  const handleSortMealData = (arr: MealType[]) => {
    let mealsArr = [];
    let allMealsArr = [];
    let activeMealsArr = [];
    let inactiveMealsArr = [];
    mealsArr = arr?.map((item: any) => {
      return {
        ...item,
        altered: false,
        meals: formatMeals(item.meals)
      };
    });

    allMealsArr = arr?.reduce((acc: any, curr: any) => {
      return [...acc, ...curr?.meals];
    }, []);

    activeMealsArr = allMealsArr?.filter((itm) => itm?.active);

    inactiveMealsArr = allMealsArr?.filter((itm) => !itm?.active);

    return { mealsArr, activeMealsArr, inactiveMealsArr, allMealsArr };
  };

  const handleMealUpdate = async (meal: any) => {
    setShopForm({
      ...meal
    });
    setShowUpdateModal(!showUpdateModal);
    setCurrentShopItem(meal);
  };

  // To update meals
  const updateMealItem = async ({
    amount,
    quantity,
    isInfinity,
    soldOutMinutes,
    isActive,
    reactivation_time
  }: any) => {
    const { id: meal_id, meal_category_id, isAddon, name }: any = currentShopItem;
    if (isAddon) {
      updateAddonItem({ amount, quantity, isInfinity, isActive });
      return;
    }

    const data = {
      active: isActive,
      amount: amount?.toString(),
      meal_id,
      meal_category_id,
      ...(reactivation_time !== '' && { reactivation_time }),
      available_no: isInfinity ? 'INFINITE' : quantity.toString(),
      name,
      availability_soon_date_:
        // @ts-ignore
        soldOutMinutes === 0 ? null : new Date(moment().add(soldOutMinutes, 'minutes'))
    };
    await apiService.put('marketing/meal', {
      data,
      baseUrl: kitchenUrl
    });
    setShowUpdateModal(false);
    onReloadData();
  };

  const updateAddonItem = async ({
    amount,
    quantity,
    isInfinity,
    isActive: active
  }: {
    amount: string;
    quantity: string;
    isInfinity: boolean;
    isActive: boolean;
  }) => {
    const { id: meal_id }: any = currentShopItem;
    const cokitchenId = localStorage.getItem(STORAGE_KEYS.COKITCHEN) as string;

    const meals = [
      {
        active,
        meal_id,
        sold_out: isInfinity || Number(quantity) > 0 ? false : true,
        availability_soon_date: moment().clone().subtract(1, 'day').format(),
        cokitchen_id: cokitchenId
      }
    ];

    await apiService.put('kitchen/related-meal', {
      data: { data: meals },
      baseUrl: kitchenUrl
    });
    setShowUpdateModal(false);
    fetchAddons();
  };
  return (
    <>
      {allMeals.map((meal) => (
        <InventoryCategory
          category={meal}
          key={meal.id}
          handleMealUpdate={handleMealUpdate}
          brandName={brandName}
          workingHours={workingHours}
        />
      ))}

      {/* Addon Category */}
      <InventoryCategory
        category={addonsObj}
        isAddon={true}
        onReloadAddon={fetchAddons}
        handleMealUpdate={(val: MealType) => handleMealUpdate({ ...val, isAddon: true })}
        brandName={brandName}
        workingHours={workingHours}
      />
      <UpdateItemModal
        show={showUpdateModal}
        loading={mealUpdateLoading}
        item={currentShopItem}
        shopForm={shopForm}
        onClose={() => setShowUpdateModal(false)}
        onConfirm={updateMealItem}
        brandName={brandName}
        workingHours={workingHours}
      />
    </>
  );
};

export default InventoryBrand;
